import { Button, H4, Image } from '@ahmdigital/ui';
import styled from 'styled-components';

export const CalloutSection = styled.div`
  display: flex;
  align-items: flex-start;
  top: -2.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    position: absolute;
  }
`;

export const CalloutText = styled(H4)`
  color: ${({ theme }) => theme.colors.purple};
`;

export const CalloutArrow = styled(Image)`
  padding-left: 0.45rem;
`;

export const StyledButton = styled(Button)`
  margin-right: auto;
  margin-top: 0.75rem;
`;
